module.exports = __webpack_public_path__ + "static/media/กุน.fd1aa04b.jpg";